/**
 * B_STATE.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Util from 'canvas/base/dev/util/B_Util';
import B_Define from 'canvas/base/dev/util/B_Define';

const B_State = (function () {

	// [V]
	const $ = {
		_play: null,
		_clear: null,
		_reason: null,
		_meta: null
	};

	class B_State {

		constructor() {

			// [S]
			this._play = B_Define.PLAY_STATUS['PLAY'];
			this._clear = B_Define.CLEAR_STATUS['GOING'];
		}

		// [V]

		// @DES :: play {bool}
		get play() {
			return this._play;
		}

		// @DES :: clear {num} - { 0 : 실패, 1 : 성공, 2 : 대기 }
		get clear() {
			return this._clear;
		}

		// @DES :: reason {str}
		get reason() {
			return this._reason;
		}

		// @DES :: meta {str or arr or obj}
		get meta() {
			return this._meta;
		}

		// [F]

		/**
		 * @DES :: 진행 초기화
		 * @INP ::
		 * @OUT ::
		 * @S.E ::
		 */
		init() {
			this._play = B_Define.PLAY_STATUS['PLAY'];
			this._clear = B_Define.CLEAR_STATUS['GOING'];
			this._reason = null;
			this._meta = null;
		}

		/**
		 * @DES :: 진행 계속
		 * @INP :: meta[obj]
		 * @S.E ::
		 */
		going(clear, reason, meta) {
			this._play = B_Define.PLAY_STATUS['PLAY'];
			this._clear = clear;
			this._reason = reason ? reason : null;
			this._meta = meta ? meta : null;
		}

		/**
		 * @DES :: 진행 중지
		 * @INP :: clear[bool], reason[str], meta[obj]
		 * @OUT ::
		 * @S.E ::
		 */
		stop(clear, reason, meta) {
			this._play = B_Define.PLAY_STATUS['STOP'];
			this._clear = clear;
			this._reason = reason ? reason : '';
			this._meta = meta ? meta : null;
		}

		/**
		 * @DES :: 상태값 새로운 객체로 전달
		 * @INP ::
		 * @OUT ::
		 * @S.E ::
		 */
		renew() {
			let rtn = {
				play: this._play,
				clear: this._clear,
				reason: this._reason,
				meta: this._meta ? this._meta._id : undefined,
			};
			this.init();
			return rtn;
		}

	}

	B_Util.manageGetAndSet(B_State, $);
	return B_State;
}());

export default B_State;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/model/B_State.js